export default "__VITE_ASSET__69cb6ed3__"